import {useIntl} from 'react-intl';
import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {useToast} from "../../../lib/hooks/useToast";
import {Calendar} from "primereact/calendar";

interface Props {
    showDialog: boolean;
    closeCb: () => void;
    createCreditNoteHandler: (note?: string, date?: Date | undefined | null) => void;
    invoiceNumber: string;
}

const CreateCreditNote : React.FC<Props> = props => {
    const {formatMessage: f} = useIntl();
    const didMountRef = useRef(false);
    const toastHelpers = useToast();

    const [note, setNote] = useState<string>();
    const [date, setDate] = useState<Date | undefined | null>();

    useEffect(() => {
        if(!didMountRef.current) {
            didMountRef.current = true;
        }
    }, []);

    const handleCreateCreditNote = () => {
        props.createCreditNoteHandler(note, date);
    }

    return <>

        <Dialog header={f({id: 'createCreditNote'}, {invoiceNumber: props.invoiceNumber})}
                onHide={props.closeCb}
                breakpoints={{'960px': '75vw', '640px': '100vw'}}
                visible={props.showDialog}>

            <p>{f({id: "confirmCreateCreditNote"}, {invoiceNumber: props.invoiceNumber})}</p>

            <div className={"grid p-fluid justify-content-center mt-4"}>
                <div className={"col-12"}>
                            <span className="p-float-label">
                                <InputText value={note} onChange={(e) => setNote(e.target.value)}/>
                                <label>{f({id: "note"})}</label>
                            </span>
                </div>

                <div className={"col-12"}>
                            <span className="p-float-label">
                                <Calendar value={date} onChange={(e) => setDate(e.value)}/>
                                <label>{f({id: "date"})}</label>
                            </span>
                </div>

                <div className={"col-12 md:col-6"}>
                    <Button label={f({id: "create"})}
                            onClick={handleCreateCreditNote}/>
                </div>

                <div className={"col-12 md:col-6"}>
                    <Button label={f({id: "cancel"})} onClick={props.closeCb}/>
                </div>
            </div>
        </Dialog>

    </>
};

export default CreateCreditNote
